import React, { useEffect, useRef, useState } from "react"
import { CircularProgress, withStyles } from "@material-ui/core"
import Header from "./components/Header"
import Scroll from "../../../../components/InfiniteScroll/Scroll"
import Table from "../../../../components/Table/Table"
import { getColumns } from "./utils/getColumns"
import AddIcon from "../../../../components/Icon/AddIcon"
import Filter from "./components/Filter/index"
import ModalContrato from "./components/ModalContrato"
import { cancelarDocumentoClienteAssinatura, findAllDocumentoClienteAssinatura } from "../../../../services/ContratoService"
import { observer } from "mobx-react-lite"
import { inject } from "mobx-react"
import { findDocumentoAssinado, findDocumentoClienteAssinaturaById, findDocumentoClienteAssinaturaByIdPlugsign, findLinkDocumentoAssinado, incluirDocumentoAssinado, findAllDocumentoModelo } from "../../../../services/DocumentoService"
import Notification from "../../../../components/Notification"
import { buildUrlDocumentoAssinado, buildUrlDownloadDocumento } from "../../../../config/config"
import { Button } from "../../../../components/ui/Buttons"
import ModalIncluirDocumentoAssinado from "./components/ModalIncluirDocumentoAssinado/ModalIncluirDocumentoAssinado"
import { getUnidadeLogado } from "../../../../services/UsuarioService"
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import PreencherDocumento from "../../../Configuracoes/ModelosDocumento/Documento/PreencherDocumento";
import DocumentTextIcon from "../../../../components/Icon/DocumentTextIcon"

const pageableDTODefault = {
  sortDir: "ASC",
  sortField: "nome",
};

const documentoAssinadoDefault={
  anexos: {},
  nome: null,
  procedimentos:[],
  profissionalSaude:null
}

const Documentos = observer(({ classes, configuracaoImpressaoStore, sujeitoAtencaoStore ,history,prontuarioStore, modeloDocumentoStore, profissionalSaudeStore, receituarioStore, documentoStore, atendimentoStore}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [openContratoModal, setOpenContratoModal] = useState(false)
  const [documentoSelecionado, setDocumentoSelecionado] = useState({})
  const [documentos, setDocumentos] = useState([]);
  const [ordenarTabela, setOrdenarTabela] = useState(pageableDTODefault);
  const [search, setSearch] = useState({})
  const [last, setLast] = useState(false);
  const [readOnly, setIsReadOnly] = useState(false)
  const [historyValue,setHistoryValue]=useState(null)
  const [isDadosFiltrados, setIsDadosFiltrados] = useState(null)
  const [openModalDocumentoAssinado,setOpenModalDocumentoAssinado]=useState(false)
  const [documentoAssinado, setDocumentoAssinado]=useState(documentoAssinadoDefault)
  const [openModalImpressao, setOpenModalImpressao] = useState(false)
  const [optionsImpressao, setOptionsImpressao] = useState([])

  const [pageableDto, setPageableDto] = useState({
    pageNumber:0,
    pageSize: 30,
    ...pageableDTODefault
  })

  const {notification}=prontuarioStore
  const {isOpen,message,variant}=notification;

  const popperRef = useRef(null);
  const dados = history.location.state


  useEffect(() => {
    setHistoryValue(dados)
  }, [])

  useEffect(()=>{
    if (historyValue?.agendamentoId && historyValue?.possuiDocumento) {
      loadContratos({isClear:true, agendamentoId:historyValue?.agendamentoId})
      setIsDadosFiltrados(true)
    }
    else if(historyValue?.agendamentoId && !historyValue?.possuiDocumento) {
      loadContratos({isClear:true})
      setOpenContratoModal(true)
    }
  },[historyValue])

  useEffect(() => {
    if(!dados){
      loadContratos({isClear:true})
    }
  }, [ordenarTabela])

  const loadContratos = async (options) => {
    const { idOpened } = sujeitoAtencaoStore;
    const pageable= options?.isClear? {...pageableDto, pageNumber:0}:pageableDto
    if(isDadosFiltrados){
      setIsDadosFiltrados(false)
    }
    const variables = {
      ...search,
      pageableDto:pageable,
      sujeitoAtencao: {
        id: idOpened,
      },
      atualizarSituacoes: true,
      ...(options?.agendamentoId && {agendamentoId:options.agendamentoId})
    }
    setIsLoading(true)
    try {
      const response = await findAllDocumentoClienteAssinatura(variables)
      const{last,content}=response
      const documentosClear = options?.isClear? [] : documentos
      setDocumentos([...documentosClear,...content])
      setLast(last)
      setPageableDto({...pageableDto,pageNumber:pageableDto.pageNumber +1})
    }
    catch (error) {
      console.error(error)
    }
    finally {
      setIsLoading(false)
    }

  }

  const handleSearchChange = (e, key) => {
    setSearch(prevSearch => ({
      ...prevSearch,
      [key]: e
    }));
  };

  const handleClickFilterButton = async () => {
    loadContratos({isClear: true})
  }

  const handleOpenContratoModal = () => {
    setOpenContratoModal(true)
  }

  const handleOpenModalDocumentoAssinado = ()=>{
    setOpenModalDocumentoAssinado(true)
  }

  const handleOpenModalImpressao = async () => {
    await getDocumentosImpressao()
    setOpenModalImpressao(true)
  }

  const getDocumentosImpressao = async () => {
    try {
      const response = await findAllDocumentoModelo({
        pageableDTO: { pageNumber: 0, pageSize: 9999, sortDir: "ASC", sortField: "nome" },
        ativo: true,
        tipo: "PROFISSIONAL_SAUDE"
      })
      setOptionsImpressao(response.content || [])
    } catch (error) {
      console.error(error)
    }
  }

  const handleClickVisualizar = async (contrato) => {
    setIsReadOnly(true)
    if (contrato) {
      const documento = await findDocumentoClienteAssinaturaById(contrato.id)
      setDocumentoSelecionado({ ...documento, destinatarios: documento.destinatario })
    }
    setOpenContratoModal(true)
  }

  const handleClickCancelar = async (contrato) => {
    try {
      await cancelarDocumentoClienteAssinatura(contrato.id)
      prontuarioStore.openNotification( "Documento cancelado!",  "success" )
      loadContratos({isClear:true})
    } catch (error) {
      prontuarioStore.openNotification("Erro ao cancelar documento!", "error" )
    }
  }

  const handleClickOrdenar = (value) => {
    const sortDir =
      ordenarTabela.sortField !== value ? 'ASC' : ordenarTabela.sortDir === 'ASC' ? 'DESC' : 'ASC'
    setOrdenarTabela({
      sortDir: sortDir,
      sortField: value,
    })
    setPageableDto({...pageableDto,sortDir:ordenarTabela.sortDir, sortField: value})
  }

  const closeContratoModal = () => {
    setHistoryValue(null)
    setOpenContratoModal(false)
    setDocumentoSelecionado({})
    setIsReadOnly(false)
  }

  const handleClickBaixar = async (item) => {
    try {
      setIsLoading(true)
      const url = await buildUrlDownloadDocumento(item.urlDownload);
      const response = await fetch(url)
      const blob = await response.blob()
      const blobUrl = URL.createObjectURL(blob)
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `${item.nome}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Erro ao baixar o arquivo:', error);
      alert('Não foi possível baixar o arquivo. Tente novamente.');
    }finally{
      setIsLoading(false)
    }
  };

  const closeNotification = () => {
    prontuarioStore.closeNotification()
  }

  const handleClickImprimirOriginal = async (item) => {
    try {
      const base64 = await findDocumentoClienteAssinaturaByIdPlugsign(item?.id);

      const link = document.createElement("a");
      link.href = "data:application/pdf;base64," + base64;
      link.download = "documento-original.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      prontuarioStore.openNotification( "Erro ao baixar!",  "success" )
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickImprimirAssinado = async (item) => {
    try {
      const variables = { idExternoAssinadoPlugsign: item?.idExternoAssinadoPlugsign };
      const base64 = await findDocumentoAssinado(variables);
      const link = document.createElement("a");
      link.href = "data:application/pdf;base64," + base64;
      link.download = "documento-original.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      prontuarioStore.openNotification( "Erro ao baixar!",  "success" )
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickImprimirAssinadoManualmente = async (item) => {
    try {
      const link = await findLinkDocumentoAssinado({
        documentoClienteAssinaturaId: item?.id,
      });
      const token = JSON.parse(localStorage.getItem("_immortal|access_token"));

      const url = buildUrlDocumentoAssinado(link, token);
      const element = document.createElement("a");
      element.href = url;
      element.target = "_blank";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (error) {
      prontuarioStore.openNotification( "Erro ao baixar!",  "success" )
    }
  };

  const handleChange = (key, value) => {
    setDocumentoAssinado((documento) => ({ ...documento, [key]: value }));
  };

  const handleChangeProcedimentos = (value) => {
    const { procedimentos = [] } = documentoAssinado;
    const hasProcedimentos = procedimentos?.some(
      (procedimento) => procedimento.id === value.id
    );
    if (hasProcedimentos) {
      return;
    }
    setDocumentoAssinado((documento) => ({
      ...documento,
      procedimentos: [...procedimentos, { id: value.id, nome: value.nome }],
    }));
  };

  const handleDeleteProcedimentos = (value) => {
    const procedimentosFormated = documentoAssinado?.procedimentos?.filter(
      (procedimento) => procedimento.id !== value.id
    );
    setDocumentoAssinado((documento) => ({
      ...documento,
      procedimentos: procedimentosFormated,
    }));
  };

  const handleClickIncluirDocumento = async () => {
    try {
      setIsLoading(true)
      const unidade = await getUnidadeLogado();

      const variables = {
        assinarDocumentoDto: {
          ...documentoAssinado,
          sujeitoAtencao: {
            id: sujeitoAtencaoStore.idOpened,
          },
          ...(documentoAssinado.profissionalSaude && {
            profissionalSaude: {
              id: documentoAssinado.profissionalSaude.id,
            },
          }),
          ...(documentoAssinado.procedimentos.length > 0 && {
            procedimentos: documentoAssinado.procedimentos,
          }),
          unidade: {
            id: unidade.id,
          },
          tipo: "DOCUMENTO",
        },
      };
      const response = await incluirDocumentoAssinado(variables);

      if (response?.id) {
        prontuarioStore.openNotification( "Documento salvo com sucesso!",  "success" )
        setOpenModalDocumentoAssinado(false);
        loadContratos({isClear:true})
      }
    } catch (error) {
      prontuarioStore.openNotification( "Erro ao Salvar!",  "error" )

    }finally{
      setIsLoading(true)
    }
  };

  return (
    <div>
      <Header handleOpenContratoModal={handleOpenContratoModal} isLoading={isLoading} />
      <div className={classes.content}>
        <Filter
          handleApplyFilter={handleClickFilterButton}
          onChange={handleSearchChange}
          filter={search}
          isLoading={isLoading}
          dadosFiltrados={isDadosFiltrados}
          text={"Documentos do agendamento "}
          textButton={"Mostrar tudo"}
          functionButton={()=>loadContratos({ isClear: true })}
        />
        <div className={classes.contentTable}>
          <Scroll
            loadMore={() => loadContratos()}
            hasMore={!last}
            pageStart={0}
            initialLoad={false}
            className={classes.scrollContainer}
          >
            <Table
              dados={documentos}
              classes={classes}
              columns={getColumns({
                popperRef,
                functionsPopper: {
                  handleClickVisualizar,
                  handleClickCancelar,
                  handleClickBaixar,
                  handleClickImprimirAssinado,
                  handleClickImprimirOriginal,
                  handleClickImprimirAssinadoManualmente
                },
              })}
              comOrdenacao
              ordenarTabela={ordenarTabela}
              handleClickOrdenar={handleClickOrdenar}
            />
            {documentos?.length === 0 && !isLoading &&
              <div className={classes.emptyMessage}>
                Nenhum registro encontrado
              </div>
            }

            {isLoading &&
              <div className={classes.circularProgress}>
                <CircularProgress color={"primary"} />
              </div>
            }

          </Scroll>
        </div>
      </div>
      <div className={classes.floatButtonsContainer}>
        <Button
          id="pac-doc-btn-imp"
          onClick={handleOpenModalImpressao}
          disabled={isLoading}
          shape={"circle"}
          bgColor={"#707C97"}
        >
          <DocumentTextIcon />
        </Button>
        <Button
          id="pac-doc-btn-upl"
          onClick={handleOpenModalDocumentoAssinado}
          disabled={isLoading}
          shape={"circle"}
          bgColor={"#707C97"}
        >
          <CloudUploadIcon />
        </Button>
        <Button
          id="pac-doc-btn-add"
          onClick={handleOpenContratoModal}
          disabled={isLoading}
          shape={"circle"}
        >
          <AddIcon />
        </Button>
      </div>

      {openContratoModal && <ModalContrato
        open={openContratoModal}
        onClose={() => closeContratoModal()}
        readOnly={readOnly}
        modeloDocumento={documentoSelecionado}
        config={configuracaoImpressaoStore.configuracaoImpressao}
        onPageChange={() => {}}
        loadContratos={loadContratos}
        history={historyValue}
      />}

      {openModalDocumentoAssinado && 
      <ModalIncluirDocumentoAssinado
        open={openModalDocumentoAssinado}
        onClose={() => setOpenModalDocumentoAssinado(false)}
        documento={documentoAssinado}
        handleChange={handleChange}
        handleProcedimentos={handleChangeProcedimentos}
        handleDeleteProcedimentos={handleDeleteProcedimentos}
        handleClickIncluirDocumento={handleClickIncluirDocumento}
        isLoading = {isLoading}
      />}

      {openModalImpressao && (
        <PreencherDocumento
          open={openModalImpressao}
          handleClose={() => setOpenModalImpressao(false)}
          options={optionsImpressao}
          sujeitoAtencaoId={sujeitoAtencaoStore.idOpened}
          sujeitoAtencao={sujeitoAtencaoStore.sujeitoAtencaoSelected}
          configuracaoImpressaoStore={configuracaoImpressaoStore}
          profissionalSaudeStore={profissionalSaudeStore}
          prontuarioStore={prontuarioStore}
          documentoStore={documentoStore}
          receituarioStore={receituarioStore}
          modeloDocumentoStore={modeloDocumentoStore}
          history={history}
          handleMinimize={() => {}}
          atendimentoStore={atendimentoStore}
          screen="Documento"
          somenteImpressao
        />
      )}

      <Notification
        isOpen={isOpen}
        message={message}
        variant={variant}
        close={closeNotification}
      />
    </div>
  )
})

const style = {
  content: {
    display: "flex",
    flexDirection: "column",
    padding: "16px 16px 0 16px",
    gap: "16px",
    justifyContent: "flex-start"
  },
  scrollContainer: {
    height: "100%",
  },
  contentTable: {
    display: "flex",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    backgroundColor: "#ffff",
    height: "calc(100vh - 325px)",
    "& .situacaoContrato": {
      padding: "4px 8px 4px 8px",
      fontWeight: 600,
      color: "#505050",
      borderRadius: "8px",
      textAlign: "center"
    },
    "& .assinado": {
      background: "#e1f3f4",
      border: "0.5px solid #007F79",
      width: "116px",
    },
    "& .naoAssinado": {
      background: "#FCF0DF",
      width: "114px",
      border: "0.5px solid #DB7C2F",
    },
    "& .cancelado": {
      background: "#FCEDEF",
      width: "107px",
      border: "0.5px solid #BF3028",
    }
  },
  divHeaderComIcon: {
    textAlign: "left !important",
    justifyContent: "flex-start !important"
  },
  floatButtonsContainer: {
    display: "flex",
    position: "absolute",
    right: "37px",
    bottom: "25px",
    gap: "8px",
  },

  emptyMessage:{
    display:"flex !important",
    justifyContent:"center !important",
    alignItems:"center !important",
    padding:"10px !important",
    fontSize:"15px !important",
    color:"#505050 !important"
  },
  circularProgress:{
    display:"flex ",
    justifyContent:"center ",
    alignItems:"center ",
    paddingTop:"10px ",
    height:"100%"
  },
  documentosFiltrados:{
    display:"flex",
    justifyContent:"space-between",
    color:"#505050",
    fontWeight:"600",
    alignItems:"center"
  },
  button:{
    width:"130px",
    borderRadius:"30px",
    textWrap:"nowrap",
    fontSize:"13px",

  }
};

const DocumentosWithStyles = withStyles(style)(Documentos)
export default inject("documentoStore", "configuracaoImpressaoStore", "sujeitoAtencaoStore","prontuarioStore", "modeloDocumentoStore", "profissionalSaudeStore", "receituarioStore", "atendimentoStore")(DocumentosWithStyles)